import React from 'react';
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import {SubscriptionNotActivePage} from "./SubscriptionNotActive";
import { withTranslation } from 'react-i18next';
import {ScreenTracker} from "../../utils/ScreenTracker";
import {SupportChatService} from "../support_chat/SupportChatService";
import {DASHBO_WHATSAPP_URL, demoCalendlyUrl} from "../../settings/settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {CLARITY_UNMASK} from '../../utils/clarity/unmask';
import {TrialCodeCard} from '../trial_code/TrialCodeForm';


// La última pantalla que ve una agencia cuya prueba venció sin pagar. Hasta el 15/10 «Agendar una
// demo» y «Extender el período de prueba» no hacían nada (los manejaba Intercom, que se cortó el
// 22/09). Cada botón cuenta su clic en `UserScreenActivity` (UD-3 de /ux).
class FreeTrialEndedPageClass extends SubscriptionNotActivePage {
    constructor(props) {
        super(props);
        this.handleRequestMoreDays = this.handleRequestMoreDays.bind(this);
    }

    componentDidMount() {
        const { t } = this.props;
        const titleKey = this._isPortalUser() ? 'free_trial_ended.portal_title' : 'free_trial_ended.page_title';
        document.title = `Dashbo - ${t(titleKey)}`;
    }

    // `PortalPrivateRoute` también manda acá al cliente de una agencia vencida. Los tres botones son
    // de la agencia, y el chat de soporte no lo atiende (`IsAgencyUser`): ve sólo qué pasa y a quién
    // escribirle (C-fserb-d0-04).
    _isPortalUser() {
        return LocalStorage.fetchUserType() === 'CLIENT_USER';
    }

    // El pedido va al chat de soporte, que llega al CC con la agencia identificada. Si el chat
    // no está (no cargó, o la agencia no lo tiene), cae a WhatsApp: `showNewMessage` caería a
    // Intercom, que está apagado, y el clic volvería a no hacer nada. Por WhatsApp llega de un
    // número desconocido, así que el texto lleva el número de agencia (C-fserb-d0-05).
    handleRequestMoreDays() {
        const { t } = this.props;
        ScreenTracker.recordEvent('free_trial_ended_extend');
        if (SupportChatService.isEnabled()) {
            SupportChatService.openWithMessage(t('free_trial_ended.extend_trial_message'));
            return;
        }
        const agencyId = LocalStorage.fetchAgencyId();
        const message = agencyId
            ? t('free_trial_ended.extend_trial_message_whatsapp', {agencyId})
            : t('free_trial_ended.extend_trial_message');
        window.open(`${DASHBO_WHATSAPP_URL}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
    }

    _renderPortalContent() {
        const { t } = this.props;
        return (<div className="row justify-content-center">
            <div className="col-md-8 text-center">
                <h1>{t('free_trial_ended.portal_title')}</h1>
                <p className="my-3">
                    {t('free_trial_ended.portal_message')}
                </p>
            </div>
        </div>)
    }

    _renderContent() {
        const { t } = this.props;
        if (this._isPortalUser()) return this._renderPortalContent();
        return (<div className="row justify-content-center">
            <div className="col-md-8 text-center">
                <h1 {...CLARITY_UNMASK}>{t('free_trial_ended.title')}</h1>
                <p className="my-3" {...CLARITY_UNMASK}>
                    {t('free_trial_ended.message1')}
                </p>
                <p {...CLARITY_UNMASK}>
                    {t('free_trial_ended.message2')}
                </p>
                <div className="col-12 text-center d-flex justify-content-center my-4">
                    <Link to="/agency/subscription" className="btn -alt" style={{textDecoration: 'none'}} {...CLARITY_UNMASK}
                          onClick={() => ScreenTracker.recordEvent('free_trial_ended_activate')}>
                        {t('free_trial_ended.activate_plan')}
                    </Link>
                </div>
                <div className="col-12 text-center d-flex justify-content-center mb-4">
                    <a href={demoCalendlyUrl('free_trial_ended')} target="_blank" rel="noopener noreferrer"
                       className="btn btn-secondary -alt -negative" style={{textDecoration: 'none'}} {...CLARITY_UNMASK}
                       onClick={() => ScreenTracker.recordEvent('free_trial_ended_demo')}>
                        {t('free_trial_ended.schedule_demo_button')}
                    </a>
                </div>
                <div className="col-12 text-center d-flex justify-content-center mb-4">
                    <Button className="-alt -negative" onClick={this.handleRequestMoreDays} {...CLARITY_UNMASK}>
                        {t('free_trial_ended.extend_trial_button')}
                    </Button>
                </div>
                {/* El código de prueba (CY-T) reabre la prueba si el alta + 30 días todavía no pasó. Aplicado,
                    la app ya guardó la prueba como en curso, así que el botón entra sin volver acá. */}
                <TrialCodeCard className="-ended" after={(
                    <Link to="/" className="btn -alt" {...CLARITY_UNMASK}
                          onClick={() => ScreenTracker.recordEvent('free_trial_ended_code_continue')}>
                        {t('trial_code.ended_continue')}
                    </Link>
                )}/>
                <div className="mt-4">
                    <p {...CLARITY_UNMASK}>
                        {t('free_trial_ended.contact_message')}
                    </p>
                </div>
            </div>
        </div>)
    }
}

export const FreeTrialEndedPage = withTranslation()(FreeTrialEndedPageClass);
